<template>
  <div class="login-container">
    <AppLogo />
    <PageHeader>Войти на сайт</PageHeader>

    <div class="login-with">
      <p>Войти с помощью</p>
      <div class="social-icons">
        <button @click="loginWith('google')" class="social-btn">
          <img :src="require('@/assets/images/icons/google.png')" alt="Google Account" />
        </button>
        <button @click="loginWith('yandex')" class="social-btn">
          <img :src="require('@/assets/images/icons/yandex.png')" alt="Yandex ID" />
        </button>
        <button @click="loginWith('vk')" class="social-btn">
          <img :src="require('@/assets/images/icons/vk.png')" alt="VK ID" />
        </button>
      </div>
    </div>

    <button @click="toggleCredentialsLogin" class="credentials-login-button">
      Вход по почте
    </button>

    <form type="POST" v-if="showCredentialsLogin" @submit.prevent="login">
      <InputField type="email" name="email" v-model="username" placeholder="Почта" />
      <!-- google please shut the f up about current-password -->
      <InputField type="password" name="password" v-model="password" placeholder="Пароль" />
      <button type="submit" class="login-button">Войти</button>

      <div class="links">
        <div class="forgot-password-container">
          <router-link to="/forgot-password" class="forgot-password">Забыли пароль?</router-link>
        </div>
      </div>
    </form>

    <div class="register">
      <p class="register-text">Нет аккаунта?</p>
      <button @click="goToRegister" class="register-button">Создать аккаунт</button>
    </div>

    <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
  </div>
</template>

<script>
import AppLogo from "@/components/auth/AppLogo.vue";
import PageHeader from "@/components/auth/PageHeader.vue";
import InputField from "@/components/auth/InputField.vue";

export default {
  components: { InputField, PageHeader, AppLogo },
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      showCredentialsLogin: false
    };
  },
  methods: {
    toggleCredentialsLogin() {
      this.showCredentialsLogin = !this.showCredentialsLogin;
    },
    async login() {
      try {
        const response = await fetch(`${process.env.VUE_APP_URL_DEV}/api/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            email: this.username,
            password: this.password,
          }),
        });

        if (!response.ok) {
          throw new Error('Ошибка авторизации');
        }

        const data = await response.json();
        const accessToken = data['data']['access_token'];
        const userId = data['data']['user_id'];

        localStorage.setItem('token', accessToken);

        const userResponse = await fetch(`${process.env.VUE_APP_URL_DEV}/api/users/${userId}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        });

        if (!userResponse.ok) {
          throw new Error('Ошибка получения данных пользователя');
        }

        const userInfo = await userResponse.json();
        localStorage.setItem('name', userInfo.data.name);
        localStorage.setItem('user_lastname', userInfo.data.user_lastname);
        localStorage.setItem('position', userInfo.data.position);
        localStorage.setItem('company', userInfo.data.company);
        localStorage.setItem('profile_picture', userInfo.data.profile_picture);

        this.$store.commit('main/setUserInfo', userInfo.data);
        this.$router.push('/chat');
      } catch (error) {
        this.errorMessage = 'Неправильный логин или пароль';
      }
    },
    loginWith(provider) {
      window.location.href = `${process.env.VUE_APP_URL_DEV}/api/login/${provider}`;
    },
    goToRegister() {
      this.$router.push('/register-first-step');
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  max-width: 400px;
  margin: auto;
  text-align: center;
}

form {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.login-button {
  background-color: #000;
  color: #fff;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 15px;
  font-weight: bold;
}

.login-button:hover {
  background-color: #333;
}

.links {
  text-align: center;
}

.forgot-password-container {
  text-align: left;
  margin-bottom: 10px;
}

.forgot-password {
  color: #000;
  text-decoration: underline;
  cursor: pointer;
}

.login-with {
  margin-bottom: 15px;
}

.login-with p {
  color: gray;
}

.social-icons {
  margin-top: 10px;
}

.social-btn {
  width: 40px;
  height: 40px;
  border: none;
  cursor: pointer;
  background: none;
  margin: 0 5px;
}

.social-btn img {
  width: 100%;
  height: 100%;
}

.credentials-login-button {
  background-color: #000;
  color: #fff;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 15px;
  font-weight: bold;
}

.credentials-login-button:hover {
  background-color: #333;
}

.register {
  margin-top: 20px;
  text-align: center;
}

.register-text {
  margin-bottom: 15px;
  color: gray;
}

.register-button {
  width: 100%;
  color: #000;
  background-color: #ccc;
  padding: 10px;
  border: 2px solid #aaa;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}

.register-button:hover {
  background-color: #bbb;
}

.error {
  color: red;
  margin-top: 15px;
}
</style>
